<template>
  <!-- Modal -->
  <div class="modal fade" id="SingleReservesModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xxl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{modalTitle}}</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="displayWarning" class="alert alert-danger">{{ translations('reserve.check_date_shipping') }}</div>

          <div style="background: #f9f9f9;float:left;width:100%;margin-bottom:20px;">
            <div :style="{ float: 'left', width: getWidth }">
              <table class="table table-striped table-align-middle">
                <thead v-if="(orderStatus === '6' || orderStatus === '14' || orderStatus === '8') && !shippingReserve">
                <tr style="background:#fff">
                  <th>{{ translations('reserve.reserve_date') }}</th>
                </tr>
                </thead>
                <thead v-if="(orderStatus === '7' || orderStatus === '8' || orderStatus === '14') && shippingReserve">
                <tr style="background:#fff">
                  <th>{{ translations('reserve.sale_date') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <div class="d-flex">
                      <input v-model="shippingAt" type="date" class="form-control input-date" @blur='changeShippingAt()' @focus="tempDateField = shippingAt" :min="minDate">
                      <input v-model="timeShippingAt" type="time" class="form-control input-time">
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div style="float:left;width:25%" v-if="(orderStatus === '7' || orderStatus === '8' || orderStatus === '14') && shippingReserve">
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff">
                  <th>{{ translations('reserve.estimated_shipping_date') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <div class="d-flex">
                      <input v-model="shippingScheduleAt" type="date" class="form-control input-date" @blur='changeShippingScheduleAt()' @focus="tempDateScheduleField = shippingScheduleAt">
                      <input v-model="timeShippingScheduleAt" type="time" class="form-control input-time">
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div style="float:left;width:25%" v-if="(orderStatus === '6' || orderStatus === '8' || orderStatus === '14') && !shippingReserve">
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff">
                  <th>{{ translations('reserve.shipping_warehouse') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <div class="dropdown">
                      <button :disabled="ordersInfo.division_type === 'B' ? true : false" id='filterByClient' class="btn btn-outline-secondary dropdown-toggle" type="button" :data-toggle="ordersInfo.division_type !== 'B' ? 'dropdown' : ''" aria-haspopup="true" aria-expanded="false">
                        {{ selectWarehouse ? selectWarehouse.name : this.translations('reserve.warehouse_selection') }}
                      </button>
                      <div class="dropdown-menu">
                        <a class='dropdown-item' v-on:click='warehouseId=0'>{{ this.translations('reserve.warehouse_selection') }}</a>
                        <a class='dropdown-item' v-for='(item, i) in warehouses' :style="item.id === disableWareHouse ? 'color:red;background:#ddd' : ''"  :key='i' v-on:click='item.id === disableWareHouse ? null :warehouseId=item.id'>
                          {{ item.name }}
                        </a>
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div style="float:left;width:25%" v-if="(orderStatus === '7' || orderStatus === '8' || orderStatus === '14') && shippingReserve">
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff">
                  <th>{{ translations('reserve.shipping_warehouse') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <button class="btn btn-outline-secondary" type="text" style="color: black" disabled>
                      {{warehouseName}}
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>

            <div style="float:left;width:25%">
              <table class="table table-striped table-align-middle">
                <thead>
                <tr style="background:#fff; height: 46px">
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>
                    <button class="btn btn-primary btn-sm" type="button" style="width: 80px; height: 34px" @click="submitSearch">{{ translations('common.search') }}</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div table-scroll>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>{{ translations('reserve.registration_date') }}</th>
                  <th>{{ translations('reserve.order_number') }}</th>
                  <th>{{ translations('reserve.bill_to') }}</th>
                  <th>{{ translations('reserve.destination_name') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="ordersInfo.division_type !== 'B'">
                  <td>
                    {{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}
                  </td>
                  <td>{{ ordersInfo.order_number }}</td>
                  <td >
                    {{ ordersInfo.client && ordersInfo.client.name ? ordersInfo.client.name : '-----------' }}
                  </td>
                  <td>
                    {{ ordersInfo.destination_name ? ordersInfo.destination_name : '--------------' }}
                  </td>
                </tr>

                <tr v-else>
                  <td>
                    {{ ordersInfo.ordered_at ? $invoiceTools.formatDateAt(ordersInfo.ordered_at) : '-----------' }}
                  </td>
                  <td>{{ ordersInfo.order_number }}</td>
                  <td >
                    {{ ordersInfo.warehouse_address_from }}
                  </td>
                  <td>
                    {{ ordersInfo.warehouse_address }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>{{ translations('reserve.line_number') }}</th>
                <th>{{ translations('reserve.jan_code') }}</th>
                <th>{{ translations('reserve.model') }}</th>
                <th>{{ translations('reserve.number_orders_received') }}</th>
                <th>{{ translations('reserve.unit_price') }}</th>
                <th>{{ translations('reserve.product_cost_new') }}</th>
                <th>{{ translations('reserve.client_order_number') }}</th>
                <th>{{ translations('reserve.division') }}</th>
                <th v-if="orderStatus==='6'">{{ translations('reserve.inventory') }}</th>
                <th>{{ translations('reserve.remaining_number_notes') }}</th>
                <th>{{ translations('reserve.all_outstanding_orders') }}</th>
                <th>{{ translations('reserve.number_reserved') }}</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(product, i) in warehouseProducts">
              <tr :key="i">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{product.jan_code}}</td>
                <td>{{product.type_number}}</td>
                <td class="right">{{product.quantity}}</td>
                <td class="right">{{product.display_price.toLocaleString()}}</td>
                <td class="right">{{product.row_price.toLocaleString()}}</td>
                <td>{{product.client_order_number}}</td>
                <td>{{(product.defective || Number(product.is_bad)) ? translations('reserve.bad') : Number(product.is_outlet) ? translations('reserve.outlet') : translations('reserve.good')}}</td>
                <td  class="right" v-if="orderStatus==='6'">{{product.stock_quantity}}</td>
                <td class="right">{{product.remain_quantity}}</td>
                <td class="right">{{product.total_remaining}}</td>
                <td v-if="product.stock_quantity>0 || (product.stock_quantity == 0 && (orderStatus==='7' || orderStatus==='8' || orderStatus==='14'))">
                  <input v-on:keyup="shippingQuantityKeyUp($event,product)" v-model="product.shippingQuantity" class="form-control form-control-sm" type="text" placeholder="0" min-value="0" :disabled="Number(product.remain_quantity) === 0">
                </td>
                <td v-else class="text-danger">{{translations('order.not_in_stock')}}</td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>

        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">{{ translations('common.close') }}</button>
          <button v-if="!shippingReserve" type="button" class="btn btn-primary" @click="handlingReserveOrders">{{ translations('common.update') }}</button>
          <button v-else type="button" class="btn btn-primary" @click="shipReserves">{{ translations('common.update') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { format } from 'date-fns'
import { OrderStatus } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'SingleReservesModal',
  components: {
    VueElementLoading
  },
  props: {
    orderID: Number,
    ordersInfo: Object,
    warehouseRedFlag: Array,
    orderStatus: String,
    reserveDetails: Array,
    shippingReserve: Boolean
  },
  data () {
    return {
      shippingAt: '',
      timeShippingAt: '',
      shippingScheduleAt: '',
      timeShippingScheduleAt: '',
      displayWarning: false,
      isSearching: false,
      warehouseProducts: [],
      tempDateField: '',
      tempDateScheduleField: '',
      warehouseId: 0,
      warehouseName: ''
    }
  },
  created () {
    this.shippingAt = format(new Date(), 'yyyy-MM-dd')
    this.timeShippingAt = format(new Date(), 'HH:mm')
    this.shippingScheduleAt = this.shippingAt
    this.timeShippingScheduleAt = this.timeShippingAt
  },
  mounted () {
    const self = this
    window.$('#SingleReservesModal').on('shown.bs.modal', function () {
      self.$store.dispatch('Master/checkMywarehouses').then(() => {
        if (self.ordersInfo.division_type && self.ordersInfo.division_type === 'B') {
          self.warehouseId = Number(self.ordersInfo.warehouse_id_from.id)
        } else {
          self.warehouseId = 57 // デシターをデフォルトに
        }
      })
      window.$('#SingleReservesModal').find('.table-scroll').css('height', (window.innerHeight - 400) + 'px')
    })

    window.$('#SingleReservesModal').on('hidden.bs.modal', function () {
      self.resetWarehouseProducts()
    })
  },
  watch: {
    shippingAt: {
      handler: function (data, oldData) {
        if (Number(data.substr(8, 2)) >= 25) {
          this.displayWarning = true
        } else {
          this.displayWarning = false
        }
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    modalTitle () {
      return this.orderStatus === '6' ? this.translations('reserve.reserve_process') : this.translations('reserve.shipping_processing')
    },
    warehouses () {
      if (this.ordersInfo.division_type && this.ordersInfo.division_type === 'B') {
        return this.$props.warehouseRedFlag
      }
      return this.$store.getters['Master/getMywarehouses']
    },
    selectWarehouse () {
      if (this.warehouses) {
        return this.warehouses.find(warehouse => warehouse.id === this.warehouseId)
      }
    },
    disableWareHouse () {
      if (this.ordersInfo.division_type && this.ordersInfo.division_type === 'B') {
        return this.ordersInfo.warehouse_id.id
      }
      return null
    },
    minDate () {
      const currentDate = new Date()
      if (Number(this.orderStatus) === OrderStatus.RESERVE_COMPLETED || Number(this.orderStatus) === OrderStatus.PARTIAL_RESERVE) {
        return currentDate.toISOString().split('T')[0]
      }
    },
    getWidth () {
      if (this.shippingReserve) {
        return '25%'
      } else {
        return '50%'
      }
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    showWarning () {
      let date = new Date().getDate()

      this.displayWarning = (date >= 25)
    },
    shippingQuantityKeyUp (event, product) {
      let { value } = event.target
      if (value && value <= 0) value = 1
      event.target.value = value
      product.shippingQuantity = value
    },

    changeShippingAt () {
      if (this.tempDateField === this.shippingAt) return
      if (!this.shippingAt) {
        this.shippingAt = new Date().toISOString().slice(0, 10)
      }
      if (!this.tempDateField) {
        this.tempDateField = this.shippingAt
      }

      this.shippingScheduleAt = this.shippingAt
      this.changeShippingScheduleAt()
    },

    changeShippingScheduleAt () {
      if (this.tempDateScheduleField === this.shippingScheduleAt) return
      if (!this.shippingScheduleAt) {
        this.shippingScheduleAt = new Date().toISOString().slice(0, 10)
      }
      if (!this.tempDateScheduleField) {
        this.tempDateScheduleField = this.shippingScheduleAt
      }
    },

    async listWarehouseProducts () {
      this.isSearching = true
      const params = {
        orders_id: this.orderID,
        shipped_at: this.shippingScheduleAt,
        warehouse_id: this.warehouseId,
        order_detail_ids: this.reserveDetails,
        shipping_reserve: this.shippingReserve
      }
      try {
        const { data } = await this.$http.post(this.$api_url.reserve_warehouse_products, params)
        if (data.status) {
          this.warehouseProducts = data.item_list
          this.warehouseProducts.forEach(item => {
            if (item.tax_included) {
              item.display_price = item.unit_price_inctax
            } else {
              item.display_price = item.unit_price
            }
            item.shippingQuantity = item.remain_quantity
            this.warehouseName = item.kaishu_warehouse_name
          })
        } else {
          this.$toastr.error(data.message, this.translations('common.error'))
        }
        await this.getQuantityRemaining()
      } catch (error) {
        this.$toastr.error(this.translations('reserve.notice_failed'), this.translations('common.error'))
      }
      this.isSearching = false
    },
    resetWarehouseProducts () {
      this.warehouseProducts = []
    },
    async handlingReserveOrders () {
      if (this.shippingAt === '') {
        this.$toastr.warning(this.translations('reserve.notice_enter_sale_date'))
        return
      }
      if (this.shippingScheduleAt === '') {
        this.shippingScheduleAt = this.shippingAt
      }

      try {
        let quantityError = false
        let shippedError = false
        let isNullDataOnWarehouse = false
        this.isSearching = true
        let productList = []
        let self = this
        this.warehouseProducts.forEach(function (product) {
          if (Number(product.shippingQuantity) > 0) {
            if (Number(product.shippingQuantity) > Number(product.stock_quantity)) { // 出荷数 > 在庫数
              quantityError = true
              return // CONTINUE
            }
            if (Number(product.shippingQuantity) > Number(product.remain_quantity)) { // 出荷数 > 注残数
              shippedError = true
              return // CONTINUE
            }

            productList.push({
              detail_id: product.detail_id,
              warehouse_id: self.warehouseId,
              defective: product.defective,
              product_id: product.product_id,
              jan_code: product.jan_code,
              type_number: product.type_number,
              unit_price: product.unit_price,
              unit_price_inctax: self.$util.getIncludeTax(product.unit_price, product.tax_rate),
              client_order_number: product.client_order_number,
              quantity: Number(product.shippingQuantity),
              younosuke_company_id: self.$parent.tempInfo.client_id,
              is_outlet: product.is_outlet,
              is_bad: product.is_bad,
              row_price: product.row_price
            })
          }

          if (Number(product.stock_quantity) <= 0) {
            isNullDataOnWarehouse = true
          }
        })
        if (quantityError) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_out_of_stock'))
          return
        }
        if (shippedError) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_valid_quantity_shipping_remaining'))
          return
        }
        if (!productList.length && isNullDataOnWarehouse) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_product_out_of_stock'))
          return
        }
        if (!productList.length) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_valid_quantity_shipping_stock'))
          return
        }
        let params = {
          orders_id: this.orderID,
          shipping_at: format(new Date(`${this.shippingAt} ${this.timeShippingAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
          shipping_schedule_at: format(new Date(`${this.shippingScheduleAt} ${this.timeShippingScheduleAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
          product_list: productList
        }
        let response = await this.$http.post(this.$api_url.handling_reserve_orders, params)

        console.log('SingleReservesModal:response', response)

        if (response.data.status === true) {
          this.$toastr.success(this.translations('reserve.notice_reserve_process_completed'), this.translations('common.success'))
          this.$parent.ordersInfo.order_status = response.data.order_status // 1:未出荷, 2:出荷済み, [3:一部出荷]
          this.tempDateField = ''
          this.$refs.closeModal.click()
          setTimeout(() => {
            location.reload()
          }, 500)
        } else {
          this.$toastr.warning(response.data.message)
        }
        this.isSearching = false
      } catch (error) {
        console.log('SingleReserveOrders:updateOrders:catch(error): ', error)
        this.$toastr.error(this.translations('reserve.notice_shipping_process_failed'), this.translations('common.error'))
        this.isSearching = false
      }
    },
    async shipReserves () {
      if (this.shippingAt === '') {
        this.$toastr.warning(this.translations('reserve.notice_enter_sale_date'))
        return
      }
      if (this.shippingScheduleAt === '') {
        this.shippingScheduleAt = this.shippingAt
      }

      try {
        let quantityError = false
        let shippedError = false
        let isNullDataOnWarehouse = false
        let checkNumberShippingQuantity = false
        let productList = []
        let productListQuantityNull = []
        let self = this
        this.warehouseProducts.forEach(function (product) {
          if (!Number.isInteger(Number(product.shippingQuantity))) {
            checkNumberShippingQuantity = true
            return
          }
          if (Number(product.shippingQuantity) >= 0) {
            if (Number(product.shippingQuantity) > Number(product.remain_quantity)) { // 出荷数 > 注残数
              shippedError = true
              return // CONTINUE
            }

            // if (Number(product.shippingQuantity) > Number(product.stock_quantity)) { // 出荷数 > 在庫数
            //   quantityError = true
            // }

            productList.push({
              detail_id: product.detail_id,
              warehouse_id: self.warehouseId,
              defective: product.defective,
              product_id: product.product_id,
              jan_code: product.jan_code,
              type_number: product.type_number,
              unit_price: product.unit_price,
              unit_price_inctax: self.$util.getIncludeTax(product.unit_price, product.tax_rate),
              client_order_number: product.client_order_number,
              quantity: Number(product.shippingQuantity),
              younosuke_company_id: self.$parent.tempInfo.client_id,
              is_outlet: product.is_outlet,
              is_bad: product.is_bad,
              row_price: product.row_price,
              remain_quantity: product.remain_quantity,
              reserved: product.reserved
            })

            if (Number(product.shippingQuantity) === 0) {
              productListQuantityNull.push({ detail_id: product.detail_id })
            }
          }
          if (Number(product.stock_quantity) <= 0) {
            isNullDataOnWarehouse = true
          }
        })
        if (checkNumberShippingQuantity) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_valid_quantity_integer'))
          return
        }
        if (shippedError) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_valid_quantity_shipping_remaining'))
          return
        }
        if (!productList.length && isNullDataOnWarehouse) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_product_out_of_stock'))
          return
        }
        if (!productList.length) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_valid_quantity_shipping_stock'))
          return
        }
        if (productList.length === productListQuantityNull.length) {
          this.isSearching = false
          this.$toastr.warning(this.translations('reserve.notice_enter_shipment_quantity'))
          return
        }

        // const today = new Date()
        // const formattedDate = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0')
        // if (this.shippingAt > formattedDate) {
        //   this.isSearching = false
        //   this.$toastr.warning(this.translations('order.notice_shipping_future_date'))
        //   return
        // }
        let params = {
          orders_id: this.orderID,
          shipping_at: format(new Date(`${this.shippingAt} ${this.timeShippingAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
          shipping_schedule_at: format(new Date(`${this.shippingScheduleAt} ${this.timeShippingScheduleAt}`), "yyyy-MM-dd'T'HH:mm:ss"),
          product_list: productList
        }

        if (quantityError) {
          this.$dialog.alert(this.translations('reserve.notice_out_of_stock'), {
            okText: this.translations('common.close')
          }).then(async () => {
            this.isSearching = false
          })
        } else {
          this.isSearching = true
          let response = await this.$http.post(this.$api_url.reserve_shipped, params)

          console.log('SingleReservesModal:response', response)
          if (response.data.status === true) {
            this.$toastr.success(this.translations('reserve.notice_shipping_process_completed'), this.translations('common.success'))
            this.$parent.ordersInfo.order_status = response.data.order_status // 1:未出荷, 2:出荷済み, [3:一部出荷]
            this.$parent.ordersInfo.outsourcing_type = response.data.outsourcing_type
            this.tempDateField = ''
            this.$refs.closeModal.click()
            await this.$http.post(this.$api_url.orders_detail, { orders_id: this.ordersInfo.parent_order_id })
            setTimeout(() => {
              location.reload()
            }, 500)
          } else {
            this.$toastr.warning(response.data.message)
          }
          this.isSearching = false
        }
      } catch (error) {
        console.log('SingleReserveOrders:updateOrders:catch(error): ', error)
        this.$toastr.error(this.translations('reserve.notice_shipping_process_failed'), this.translations('common.error'))
        this.isSearching = false
      }
    },
    async getQuantityRemaining () {
      try {
        const { data: { data, status } } = await this.$http.post(this.$api_url.orders_quantity_remaining, { order_id: this.orderID })
        if (status) {
          this.warehouseProducts.forEach((product) => {
            const findProduct = data.find((quantity) => quantity.product_id === product.product_id)
            if (findProduct) {
              this.$set(product, 'total_remaining', findProduct.total_remaining)
            }
          })
        }
      } catch (error) {}
    },
    submitSearch () {
      this.listWarehouseProducts()
    }
  }
}
</script>

<style scoped>
.input-date {
  width: 160px;
}
</style>
